import BaseModal from './BaseModal';
import { Button } from '../../actions/Button';

const Modal: typeof BaseModal = ({ ...props }) => <BaseModal ButtonComponent={Button} {...props} />;

Modal.displayName = 'Modal';
export default Modal;
